import React, { Component } from 'react';
import './App.css';


//redux 
import {connect} from 'react-redux'
import { authenticate_firebase_user } from './Actions/authAction'

//react router dom
import { BrowserRouter,  Route, Switch, Redirect } from "react-router-dom";


//New Components
import Dashboard from './Components/Pages/MyHaven/Dashboard/Dashboard';
import LoginPage from "./Components/Pages/MyHaven/LoginPage/LoginPage";
import Register from "./Components/Pages/MyHaven/LoginPage/Register";
import HavenReferrals from './Components/Pages/MyHaven/HavenReferrals/HavenReferrals'
import HavenFaq from './Components/Pages/MyHaven/Faq/Faq'
import ResetPassword from './Components/Pages/MyHaven/LoginPage/ResetPassword'
import LoadingComponent from './Components/LoadingComponent/LoadingComponent';
import ReferralsLogin from './Components/Pages/MyHaven/LoginPage/ReferralsLogin';


const PrivateRoute = ({ component: Component, authenticated, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      authenticated !== null ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

const firstChild = props => {
  const childrenArray = React.Children.toArray(props.children);
  return childrenArray[0] || null;
};

class App extends Component {

  render() {

    return (
      <div className="App">
        <BrowserRouter >  
         <LoadingComponent>
           <Switch>
             <Route path = "/" exact render={(props) => <LoginPage {...props}/>} />
             <Route path = "/referrals" exact render={(props) => <ReferralsLogin {...props}/>} />        
             <Route path = "/reset-password" exact render={(props) => <ResetPassword {...props} />} />
             <Route path = "/register" exact render={(props) => <Register {...props} />} />
             <PrivateRoute path = "/dashboard" exact component = {Dashboard} authenticated = {this.props.is_authenticated_prop}/>
             <PrivateRoute path = "/dashboard/referrals" exact  component = {HavenReferrals}  authenticated = {this.props.is_authenticated_prop}/>
             <PrivateRoute path = "/dashboard/faq" exact  component = {HavenFaq} authenticated = {this.props.is_authenticated_prop}/>
             <Route render={function () {return <h1>404 PAGE NOT FOUND</h1>}} />
           </Switch>
         </LoadingComponent>
       </BrowserRouter>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      is_authenticated_prop: state.is_authenticated.is_authenticated 
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

      authenticate_prop_from_action: () => dispatch(authenticate_firebase_user("GET_AUTH"))
  }
}
export default connect(mapStateToProps, mapDispatchToProps) (App);




// WEBPACK FOOTER //
// ./src/App.jsx